let UID = 0;
export default function uid(asString = false): string | number {
  // eslint-disable-next-line no-plusplus
  return asString ? String(++UID) : ++UID;
}
